import { useTranslation } from 'react-i18next';

export const SkipLink = () => {
  const { t } = useTranslation('common');

  return (
    <a
      href="#main-content"
      className="focus-ring sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[200] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
    >
      {t('skipLink')}
    </a>
  );
};
